import React from 'react';
import { Col } from 'reactstrap';
import moment from 'moment';
import './BookingAgentGeneralInfo.scss';

function BookingAgentGeneralInfo({ data }) {
  function getSelectedServices() {
    const services = {
      Flight: data?.Flight,
      Visa: data?.Visa,
      Hotel: data?.Hotel,
      'Travel Insurance': data?.TravelInsurance,
      'Airport Transfer': data?.AirportTransfer,
    };

    return (
      Object.entries(services)
        .filter(([, value]) => value === 'Y')
        .map(([key]) => key)
        .join(', ') || '-'
    );
  }

  return (
    <div className="d-flex flex-column gap-2">
      <div>
        <span className="fs-6 fw-semibold">General Information</span>
      </div>
      <div className="gap-2 ba-general-info">
        <div className="d-flex flex-row align-items-start justify-content-between gap-1">
          <Col lg={3} className="external-filter-col">
            <span className="ba-general-info-label">Request Date</span>
            <span>{moment(data?.ReqDate).format('LL')}</span>
          </Col>
          <Col lg={3} className="external-filter-col">
            <span className="ba-general-info-label">Type of Traveller</span>
            <span>{data?.TravelerType_Description}</span>
          </Col>
          <Col lg={3} className="external-filter-col">
            <span className="ba-general-info-label">Type of Travel</span>
            <span>{data?.TravelType_Description}</span>
          </Col>
          <Col lg={3} className="external-filter-col">
            <span className="ba-general-info-label">Employee Name</span>
            <span>{data?.UserFullName}</span>
          </Col>
        </div>
        <div className="d-flex flex-row align-items-start justify-content-between mt-3 gap-1">
          <Col lg={3} className="external-filter-col">
            <span className="ba-general-info-label">Traveller Name</span>
            <div className="d-flex flex-row align-items-center gap-1">
              <span>{data?.Traveler_FName}</span>
              <span>{data?.Traveler_MName}</span>
              <span>{data?.Traveler_LName}</span>
            </div>
          </Col>
          <Col lg={3} className="external-filter-col">
            <span className="ba-general-info-label">Requirements</span>
            <span>{getSelectedServices()}</span>
          </Col>
          <Col lg={3} className="external-filter-col">
            <span className="ba-general-info-label">Purpose of Travel</span>
            <div className="purpose-of-travel-container">
              <span>{data?.TravelPurpouse}</span>
            </div>
          </Col>
          {data?.Status === 'Request for Rebooking' ? (
            <Col className="external-filter-col">
              <span className="ba-general-info-label">Modify Comments</span>
              <div className="purpose-of-travel-container">
                <p
                  className="mb-0"
                  style={{ justifyContent: 'justify', textAlign: 'justify' }}
                >
                  {data?.RevisionRemarks === '' ? '-' : data?.RevisionRemarks}
                </p>
              </div>
            </Col>
          ) : (
            <Col lg={3} className="external-filter-col">
              <span className="ba-general-info-label">Comments</span>
              <div className="purpose-of-travel-container">
                <p
                  className="mb-0"
                  style={{ justifyContent: 'justify', textAlign: 'justify' }}
                >
                  {data?.TravelComments === '' ? '-' : data?.TravelComments}
                </p>
              </div>
            </Col>
          )}
        </div>
      </div>
    </div>
  );
}

export default BookingAgentGeneralInfo;
